import { defineMessages } from 'react-intl';

export default defineMessages({
    heading: {
        id: 'ml.gateway.quoteandbind.cr.pa.validateinfo.heading',
        defaultMessage: 'Validate information for auto'
    },
    infoMessage: {
        id: 'ml.gateway.quoteandbind.cr.pa.validateinfo.info message',
        defaultMessage: 'Some information provided doesn\'t match our records or is based on defaults. Please update by selecting and verifying the correct information.'
    },
    baseCRWizardMessage: {
        id: 'ml.gatewayquoteandbind.cr.pa.validateinfo.wizardMessageCR',
        defaultMessage: 'Next, we’ll {nextStep}'
    },
    nextButtonMessageToQuoteDetail: {
        id: 'ml.gatewayquoteandbind.cr.pa.validateinfo.your quote',
        defaultMessage: 'review your quote!'
    },
    electronicToPaperWarning: {
        id: 'ml.gatewayquoteandbind.cr.pa.validateinfo.electronicToPaperWarning',
        defaultMessage: '<b>A valid email address is required to receive electronic communications. If you don’t enter an email address, the paperless discount will be removed.</b><br></br>Please review before proceeding.'
    },
    priorInsuranceInfoMessage: {
        id: 'ml.gatewayquoteandbind.cr.pa.validateinfo.priorInsuranceWarning',
        defaultMessage: 'The Prior Insurance information on this screen is from a prior policy with us, or from another insurance carrier’s information on a consumer report.  Any field that contains this information cannot be changed.  For questions or to dispute the information from a prior policy with us, please contact us.  For questions or to dispute information from another insurance carrier, consumers should contact the LexisNexis Consumer Service Center by phone at 800-456-6004, by mail at PO Box 105108 Atlanta, GA 30348-5108, or online at www.consumerdisclosure.com.'
    },
    changedToMarriedButNoSpouse: {
        id: 'ml.gatewayquoteandbind.cr.pa.validateinfo.was changed to married but no spouse was selected.  Please review.',
        defaultMessage: 'was changed to married but no spouse was selected.  Please review.'
    },
    verifyEmail:{
        id:'ml.gatewayquoteandbind.cr.pa.validateinfo.verifyEmail',
        defaultMessage:"Enter a valid email address"
    },
    invalidEmail:{
        id:'ml.gatewayquoteandbind.cr.pa.validateinfo.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    somethingWentWrong: {
        id: 'ml.gatewayquoteandbind.cr.pa.validateinfo.Something went wrong during this process.  Please try again.',
        defaultMessage: 'Something went wrong during this process.  Please try again.'
    },
    FarmersSubCompany_Ext: {
        "id": "ml.gatewayquoteandbind.cr.pa.validateinfo.Please Specify Company.",
        "defaultMessage": "Please Specify Company."
    },
    CompanyPolicyNumber_Ext: {
        "id": "ml.gatewayquoteandbind.cr.pa.validateinfo.Please enter a Policy Number.",
        "defaultMessage": "Please enter a Policy Number."
    },
    TenureOriginalEffDate_Ext: {
        "id": "ml.gatewayquoteandbind.cr.pa.validateinfo.Please enter an Original Effective Date for the Prior Policy",
        "defaultMessage": "Please enter an Original Effective Date for the Prior Policy."
    },
    duplicateSpouseContactUsError: {
        "id": "ml.gatewayquoteandbind.cr.pa.validateinfo.Invalid relationship assignment: The PNI cannot have multiple spouses. Please correct the duplicate spouse relationship before proceeding.",
        "defaultMessage": "Invalid relationship assignment: The PNI cannot have multiple spouses. Please correct the duplicate spouse relationship before proceeding."
    },
    duplicateSpouseReturnToPrefillError: {
        "id": "ml.gatewayquoteandbind.cr.pa.validateinfo.Marital status mismatch found. Verify the driver's status and ensure the relationship to insured is correct on the Prefill Results screen.",
        "defaultMessage": "Marital status mismatch found. Verify the driver's status and ensure the relationship to insured is correct on the Prefill Results screen."
    },
    resolveHVQDiscrepancies:{
        "id": "ml.gatewayquoteandbind.cr.pa.validateinfo.Resolve HVQ discrepancies.",
        "defaultMessage": "Resolve HVQ discrepancies..."
    }
});